import React from 'react';

import Stats from './Stats';
import Code from './Code';
import InlineCode from './InlineCode';

const CodeBlock = ({ children, className = null, ...props }) => {
  if (!children) return null;
  if (!className) return <InlineCode {...{ children }} />;

  const language = className.replace(/lang(uage)?-/, '');

  switch (language) {
    case 'stats': {
      const code = JSON.parse(children);

      return <Stats children={code} />;
    }
    default:
      return <Code {...{ children, className, language, ...props }} />;
  }
};

export default CodeBlock;
